// setUserProperties({
//   'favorite_color': 'blue',
//   'age': 18
// });
export function setUserProperties(userProperties) {
  if (typeof gtag === 'function' && window.location.hostname === 'kakaakowine.com') {
    gtag('set', 'user_properties', userProperties);
  }
}

// track("search", {
//   search_term: "t-shirts",
//   tbm: "isch"
// });
export function track(eventName, eventParams) {
  if (typeof gtag === 'function' && window.location.hostname === 'kakaakowine.com') {

    gtag('event', `custom_checkout_${eventName}`, eventParams)
  }
}

export default {
  setUserProperties,
  track,
}
